import React from "react";
import ReactSelect from "react-select";
import PropTypes from "prop-types";
import "./Select.scss";

const Select = ({
  className,
  options,
  baseClass,
  isClearable,
  hasError,
  selectedOption,
  ...props
}) => (
  <ReactSelect
    className={`${baseClass} ${className} text-2.5sm md:text-[16px] md:leading-[24px] font-medium font-body`}
    options={options}
    isOptionDisabled={(o) => o?.disabled}
    isClearable={isClearable}
    value={selectedOption}
    defaultValue={selectedOption}
    classNames={{
      control: (state) =>
        `cselect-controls ${state.isFocused ? "!border-cf-green" : ""} ${
          hasError ? "!border-red-500" : ""
        }`,
      valueContainer: () => "cselect-value-container",
      menuList: () => `cselect-menulist`,
      option: () => "cselect-option",
    }}
    styles={{
      dropdownIndicator: (base, state) => ({
        ...base,
        transition: "all .2s ease",
        transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
      }),
      placeholder: (base) => ({
        ...base,
        whiteSpace: "nowrap",
        fontSize: 14,
        lineHeight: "24px",
        fontWeight: 400,
        color: "#240253",
        opacity: 0.5,
      }),
      control: (base) => ({
        ...base,
        borderRadius: 4,
        minHeight: 44.6,
        boxShadow: "none",
        borderColor: "none",
      }),
      menuList: (base) => ({
        ...base,
        padding: "4px",
      }),
      valueContainer: (base) => ({
        ...base,
        color: "#240253",
      }),
      option: (base, state) => {
        return {
          ...base,
          // eslint-disable-next-line no-nested-ternary
          backgroundColor:
            state.isSelected || state.isFocused
              ? "rgba(105, 51, 211, 0.1)"
              : base.backgroundColor,
          borderBottomStyle: "solid",
          paddingLeft: 8,
          ":active": {
            color: "rgba(#6933D3, 0.8)",
          },

          color: state.isSelected ? "#6933D3" : base.color,
          fontWeight: state.isSelected ? 400 : 400,
        };
      },
    }}
    {...props}
    // components={{
    //   IndicatorSeparator: () => null,
    // }}
  />
);
Select.propTypes = {
  className: PropTypes.string,
  baseClass: PropTypes.string,
  hasError: PropTypes.bool,
  selectedOption: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
  isClearable: PropTypes.bool,
};
Select.defaultProps = {
  className: "",
  isClearable: false,
  baseClass: "md:min-w-[216px]",
  hasError: false,
  options: [],
  selectedOption: null,
};
export default Select;
